import Swiper from "swiper";

function showTestimonials () {
    if ( $( '.c-testimonials__stories-slide-item ' ).length <= 1 ) {
        $( '.c-testimonials__stories-slider-wrapper' ).addClass( 'c-testimonials__stories-slider-wrapper--disabled' );

        $( '.c-testimonials__stories-slider-btn-prev' ).addClass( 'c-testimonials__stories-slider-btn-prev--disabled' );
        $( '.c-testimonials__stories-slider-btn-next' ).addClass( 'c-testimonials__stories-slider-btn-next--disabled' );

    } else {
        $( '.c-testimonials__stories-slider-wrapper' ).removeClass( 'c-testimonials__stories-slider-wrapper--disabled' );

        $( '.c-testimonials__stories-slider-btn-prev' ).removeClass( 'c-testimonials__stories-slider-btn-prev--disabled' );
        $( '.c-testimonials__stories-slider-btn-next' ).removeClass( 'c-testimonials__stories-slider-btn-next--disabled' );

        let swiperPartnersLogos = new Swiper( '.c-testimonials__stories-slider-container', {
            loop: true,
            speed: 600,
            slidesPerView: 1,
            spaceBetween: 48,
            pagination: {
                el: '.c-testimonials__stories-slider-pagination',
                clickable: true
            },
            navigation: {
                prevEl: '.c-testimonials__stories-slider-btn-prev',
                nextEl: '.c-testimonials__stories-slider-btn-next'
            }
        } );
    }

    if ( $( '.c-testimonials__brands-slider-item ' ).length > 4 ) {
        $( '.c-testimonials__brands-slider-wrapper' ).removeClass( 'c-testimonials__brands-slider-wrapper--disabled' );

        let swiperStatements = new Swiper( '.c-testimonials__brands-slider-container', {
            loop: true,
            speed: 600,
            autoplay: {
                delay: 4000
            },
            breakpoints: {
                320: {
                    slidesPerView: 1,
                    spaceBetween: 15
                },
                375: {
                    slidesPerView: 2,
                    spaceBetween: 20
                },
                544: {
                    slidesPerView: 3,
                    spaceBetween: 30
                },
                992: {
                    slidesPerView: 4,
                    spaceBetween: 46
                }
            }
        } );

    } else {
        $( '.c-testimonials__brands-slider-wrapper' ).addClass( 'c-testimonials__brands-slider-wrapper--disabled' );
    }
}

export default showTestimonials;
